export const INK = "#2b1a0e";
export const MUTED = "#8a7566";
export const ACCENT = "#a95e2c";
export const LINE = "#ece0d8";
export const ZEBRA = "#faf4f0";

const TR_ASCII = { ç: "c", ğ: "g", ı: "i", ö: "o", ş: "s", ü: "u" };

export const slug = (text) =>
  text
    .toLocaleLowerCase("tr")
    .replace(/[çğıöşü]/g, (ch) => TR_ASCII[ch])
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

export const loadPdfMake = async () => {
  const [{ default: pdfMake }, { default: vfs }] = await Promise.all([
    import("pdfmake/build/pdfmake"),
    import("pdfmake/build/vfs_fonts"),
  ]);

  pdfMake.addVirtualFileSystem(vfs);

  return pdfMake;
};
